export default "__VITE_ASSET__bf47bd45__"